<template>
  <div>
    <button
      type="button"
      class="btn btn-dark btn-with-addon"
      size="small"
      @click="showModal"
      :disabled="this.declareState !== 0 ? true : false"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-upload" />
      </span>
      Bulk
    </button>
    <a-modal
      v-model="visible"
      :title="`Bulk grades mark upload for ${className}`"
      :width="680"
      style="top: 20px;"
      @cancel="handleCancel"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="handleSubmit"
          >Upload</a-button
        >
      </template>
      <a-form :form="form">
        <!-- <button @click="exportToCsv">export to CSV</button> -->
        <p class="mt-3 mb-0">
          Download the CSV file format here.
          <a
            @click="exportToCsv"
            class="btn btn-sm btn-primary btn-with-addon mx-3"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-download" />
            </span>
            Download CSV
          </a>
          <span class="font-weight-bold text-warning"
            >Fields marked with * are required!</span
          >
        </p>
        <br />
        <p class="mb-1">
          Excell sheet formats subject order should exactly same as below:
        </p>
        <a-divider />
        <div class="row">
          <div class="col-md-3"></div>
          <div class="col-md-6">
            <br />
            <table
              class="table table-sm table-sm-responsive table-bordered text-center"
            >
              <tr>
                <th>Roll No</th>
                <th v-for="(sub, index) in this.subjects" :key="index">
                  {{ sub.name }}
                </th>
              </tr>
            </table>
          </div>
          <div class="col-md-3"></div>
        </div>
        <a-divider />
        <div class="row">
          <div class="col-md-4">
            <a-form-item label="CSV File">
              <a-upload
                v-decorator="[
                  'file',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Please select a csv file to upload!'
                      }
                    ]
                  }
                ]"
                accept=".csv, application/vnd.ms-excel, text/csv"
                :fileList="fileList"
                :multiple="false"
                :remove="handleRemove"
                :beforeUpload="beforeUpload"
                :disabled="uploadDisabled"
              >
                <a-button v-if="!uploadDisabled">
                  <a-icon type="upload" /> Select File
                </a-button>
              </a-upload>
            </a-form-item>
          </div>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
const options = {
  showLeafArrayIndexes: true,
  includeNullValues: false,
  mapping: function(value) {
    if (typeof value === 'boolean') {
      return +value ? '1' : '0'
    }
    return value
  },
}

export default {
  name: 'BulkUploadStudentMark',
  props: [
    'section',
    'className',
    'class_id',
    'sessionId',
    'settingId',
    'subjects',
    'declareState',
  ],
  mounted: function() {
    this.subjectSpinning = true
  },
  watch: {
    subs: function(value) {
      return value
    },
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      uploadDisabled: false,
      fileList: [],
      secs: [],
      subjectSpinning: false,
      sectionData: [],
      selectedSection: null,
      subs: [],
    }
  },
  methods: {
    exportToCsv() {
      var subNameList = ['Roll']
      this.subjects.forEach(function(subDetails) {
        subNameList.push(subDetails.name)
      })
      // var Results = []
      var CsvString = ''
      // Results.forEach(function(RowItem, RowIndex) {
      subNameList.forEach(function(ColItem, ColIndex) {
        CsvString += ColItem + ','
      })
      CsvString += '\r\n'
      // })
      CsvString = 'data:application/csv,' + encodeURIComponent(CsvString)
      var x = document.createElement('A')
      x.setAttribute('href', CsvString)
      x.setAttribute('download', `FinalReultCsvFormat-${this.className}.csv`)
      document.body.appendChild(x)
      x.click()
    },
    showModal() {
      this.visible = true
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      const newFileList = this.fileList.slice()
      newFileList.splice(index, 1)
      this.fileList = newFileList
      this.uploadDisabled = false
    },
    beforeUpload(file) {
      const isCSV =
        file.type === 'application/vnd.ms-excel' || file.type === 'text/csv'
      if (!isCSV) {
        this.$message.error('You can only upload CSV file!')
        return false
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('File must smaller than 2MB!')
        return false
      }
      this.fileList = [...this.fileList, file]
      // return isJPG && isLt2M
      this.uploadDisabled = true
      return false
    },
    getSection(e) {
      this.selectedSection = e
    },
    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to bulk upload students grades!`,
            onOk: () => {
              var subList = []
              this.subjects.forEach(function(subDetails) {
                subList.push(subDetails.id)
              })
              values.class_id = this.class_id
              values.session_id = this.sessionId
              values.setting_id = this.settingId
              values.section_id = this.section
              values.subject_ids = subList
              let formData = window.jsonToFormData(values, options)

              const csvFile = values.file.file
              formData.append('file', csvFile)

              this.$http
                .post('/api/bosem/finalresult/marks/bulkimport', formData)
                .then(({ data }) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Marks uploaded!',
                    description: `Bulk students marks import completed!`,
                  })
                  this.fileList = []
                  this.uploadDisabled = false
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.form.resetFields()
      this.visible = false
    },
  },
}
</script>
